import React, { useCallback, useContext, useEffect, useState } from "react";
import { Link, useNavigate, createSearchParams } from "react-router-dom";
import NavData from "../static-data/NavItems.json";
import MobileNav from "./MobileNav";
import AboutDrpDwn from "./nav-dropdowns/AboutDrpDwn";
import ExploreLocalDrpDwn from "./nav-dropdowns/ExploreLocalDrpDwn";
import GlobalPkgDrpDwn from "./nav-dropdowns/GlobalPkgDrpDwn";
import LanguageService from "../../services/Language.service";
import LangContext, { langCode } from "../../context/LangContext";
import Languages from "./nav-dropdowns/Languages";
import logoImg from "../../resources/images/theme logo (2).png";
import { MdEmail } from "react-icons/md";
import { AiFillPhone } from "react-icons/ai";
import SocialMedia from "./SocialMedia";
import TrivAdvisorLogo from "../../resources/images/TripAdvisor_Logo.svg.png";
import ContactDetails from "../static-data/ContactDetails.json";
export interface routeType {
  "nav-item": {
    en: string;
    fr: string;
  };
  to: string;
}
function Nav() {
  const [scrollActive, setScrollActive] = useState(false);
  const [mouseOverActive, setMouseOverActive] = useState(false);
  const [hoverNavItem, setHoverNavItem] = useState("");
  const [activePage, setActivePage] = useState("Home");
  const [languages, setLanguages] = useState<langsType[]>([]);

  const { lang, setLang, lang_code } = useContext(LangContext);
  const [activeLang, setActiveLang] = useState(lang);

  let navigate = useNavigate();

  const handleDropdown = (isMouseOver: boolean, navItem: string) => {
    isMouseOver ? setMouseOverActive(true) : setMouseOverActive(false);
    setHoverNavItem(navItem);
  };

  const handleRoute = useCallback(
    (route: routeType, searchParam: {} | null) => {
      setActivePage(`${route["nav-item"][`${lang_code}`]}`);
      if (searchParam) {
        navigate({
          pathname: `${route.to}`,
          search: createSearchParams(searchParam).toString(),
        });
      } else {
        navigate({
          pathname: `${route.to}`,
        });
      }
    },
    []
  );

  const createScrollNavEffect = () => {
    if (window.scrollY >= 252) {
      setScrollActive(true);
      return;
    } else {
      setScrollActive(false);
      return;
    }
  };
  window.addEventListener("scroll", createScrollNavEffect);

  return (
    <>
      <div className="bg-primary-dark-600 text-white py-2">
        <div className="container mx-auto px-4 lg:px-8 flex items-center justify-between">
          {" "}
          <div className="hidden md:block">
            <div className="flex items-center space-x-2 ">
              <MdEmail />
              <a
                href="mailto:himalayanultimatetrek@gmail.com"
                className="text-sm flex items-center space-x-4"
              >
                {ContactDetails.email}
              </a>

              <AiFillPhone className="ml-4" />
              <a
                href="tel:9841434657"
                className="text-sm flex items-center space-x-4"
              >
                {ContactDetails.phone}
              </a>
            </div>
          </div>
          <div>
            {/* <SocialMedia color="white" className="absolute top-2 text-2xl" /> */}

            <a
              href="https://www.tripadvisor.com/Attraction_Review-g424934-d10854407-Reviews-Himalayan_Ultimate_Trekking_Nepal-Bhaktapur_Kathmandu_Valley_Bagmati_Zone_Centra.html"
              target="_blank"
            >
              <img src={TrivAdvisorLogo} alt="" className="w-36" />
            </a>
          </div>
        </div>
      </div>

      <div className="absolute w-full">
        <div
          className={`z-20  text-white max-h-24 ${
            scrollActive
              ? " bg-primary-base fixed top-0 animate-from-top w-full"
              : " transition ease-out duration-300 bg-transparent relative"
          }`}
        >
          <div className="lg:hidden">
            <MobileNav handleRoute={handleRoute} activePage={activePage} />
          </div>
          {/* Desktop Nav Section  */}
          <div className="hidden lg:flex items-center  xl:px-8 justify-between container mx-auto">
            <div className="font-bold cursor-pointer">
              <a href="/">
                <img
                  src={logoImg}
                  alt="Himalayan Ultimate Trekking Nepal"
                  className="w-80 -mt-2"
                />
              </a>
            </div>
            {/* right section  */}
            <div className="flex items-center space-x-6 cursor-pointer font-medium">
              {/* Home Nav  */}
              <p
                className={`relative ${
                  scrollActive
                    ? "hover:text-secondary-base py-8"
                    : "hover:text-primary-base py-12"
                } ${
                  activePage === `${[NavData[0]["nav-item"]]}` &&
                  "text-secondary-base"
                }`}
                onClick={() => handleRoute(NavData[0], null)}
              >
                {NavData[0]["nav-item"][`${lang_code}`]}
              </p>

              {/* Global Packages Nav  */}
              <div
                className={`relative ${
                  scrollActive
                    ? "hover:text-secondary-base py-8"
                    : "hover:text-primary-base py-12"
                } ${
                  activePage === `${[NavData[1]["nav-item"]]}` &&
                  "text-secondary-base"
                }`}
                // onClick={() => handleRoute(NavData[1])}

                onMouseOverCapture={() =>
                  handleDropdown(true, NavData[1]["nav-item"][`${lang_code}`])
                }
                onMouseOutCapture={() =>
                  handleDropdown(false, NavData[1]["nav-item"][`${lang_code}`])
                }
              >
                {NavData[1]["nav-item"][`${lang_code}`]}
                {mouseOverActive &&
                hoverNavItem === NavData[1]["nav-item"][`${lang_code}`] ? (
                  <GlobalPkgDrpDwn handleRoute={handleRoute} />
                ) : (
                  ""
                )}
              </div>

              {/* Explore Local Nav  */}
              <div
                className={`relative ${
                  scrollActive
                    ? "hover:text-secondary-base py-8"
                    : "hover:text-primary-base py-12"
                } ${
                  activePage === `${[NavData[2]["nav-item"]]}` &&
                  "text-secondary-base"
                }`}
                // onClick={() => handleRoute(NavData[2], null)}
                onMouseOverCapture={() =>
                  handleDropdown(true, NavData[2]["nav-item"][`${lang_code}`])
                }
                onMouseOutCapture={() =>
                  handleDropdown(false, NavData[2]["nav-item"][`${lang_code}`])
                }
              >
                {NavData[2]["nav-item"][`${lang_code}`]}
                {mouseOverActive &&
                hoverNavItem === NavData[2]["nav-item"][`${lang_code}`] ? (
                  <ExploreLocalDrpDwn handleRoute={handleRoute} />
                ) : (
                  ""
                )}
              </div>

              {/* Travel Guide Nav  */}
              <p
                className={`relative ${
                  scrollActive
                    ? "hover:text-secondary-base py-8"
                    : "hover:text-primary-base py-12"
                } ${
                  activePage === `${[NavData[3]["nav-item"]]}` &&
                  "text-secondary-base"
                }`}
                onClick={() => handleRoute(NavData[3], null)}
              >
                {NavData[3]["nav-item"][`${lang_code}`]}
              </p>

              {/* Blogs Guide Nav  */}
              <p
                className={`relative ${
                  scrollActive
                    ? "hover:text-secondary-base py-8"
                    : "hover:text-primary-base py-12"
                } ${
                  activePage === `${[NavData[4]["nav-item"]]}` &&
                  "text-secondary-base"
                }`}
                onClick={() => handleRoute(NavData[4], null)}
              >
                {NavData[4]["nav-item"][`${lang_code}`]}
              </p>

              {/* Review Guide Nav  */}
              <p
                className={`relative ${
                  scrollActive
                    ? "hover:text-secondary-base py-8"
                    : "hover:text-primary-base py-12"
                } ${
                  activePage === `${[NavData[5]["nav-item"]]}` &&
                  "text-secondary-base"
                }`}
                onClick={() => handleRoute(NavData[5], null)}
              >
                {NavData[5]["nav-item"][`${lang_code}`]}
              </p>

              {/* About us Guide Nav  */}
              <div
                className={`relative ${
                  scrollActive
                    ? "hover:text-secondary-base py-8"
                    : "hover:text-primary-base py-12"
                } ${
                  activePage === `${[NavData[6]["nav-item"]]}` &&
                  "text-secondary-base"
                }`}
                onClick={() => handleRoute(NavData[6], null)}
                // onMouseOverCapture={() =>
                //   handleDropdown(true, NavData[6]["nav-item"][`${lang_code}`])
                // }
                // onMouseOutCapture={() =>
                //   handleDropdown(false, NavData[6]["nav-item"][`${lang_code}`])
                // }
              >
                {NavData[6]["nav-item"][`${lang_code}`]}
                {/* {mouseOverActive &&
              hoverNavItem === NavData[6]["nav-item"][`${lang_code}`] ? (
                <AboutDrpDwn />
              ) : (
                ""
              )} */}
              </div>

              {/* Contact us Guide Nav  */}
              <p
                className={`relative ${
                  scrollActive
                    ? "hover:text-secondary-base py-8"
                    : "hover:text-primary-base py-12"
                } ${
                  activePage === `${[NavData[7]["nav-item"]]}` &&
                  "text-secondary-base"
                }`}
                onClick={() => handleRoute(NavData[7], null)}
              >
                {NavData[7]["nav-item"][`${lang_code}`]}
              </p>

              {/* langugae nav  */}
              <Languages scrollActive={scrollActive} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Nav;
